<div class="space-y-6">
  <app-page-header
    [backTo]="['/permissions/resources']"
    backLabel="Retour aux resources"
    title="Nouvelle resource"
  />

  <app-resource-form
    mode="create"
    [submitting]="submitting()"
    [serverError]="serverError()"
    (save)="onSave($event)"
    (cancel)="onCancel()"
  />
</div>
